import config from "../../../config.js";

function authHeader() {
    return {
        "Accept": "application/json",
        "Content-Type":"application/json"
    }
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {//interceptor
                //console.log("401",response);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

export const http = {
    get: (url) => {
        const requestOptions = {
            method: "GET",
            headers: authHeader()
        };
        return fetch(config.apiUrl + url, requestOptions).then(handleResponse);
    },
    post: (url, data) => {
        const requestOptions = {
            method: "POST",
            headers: authHeader(),
            body: JSON.stringify(data),
        };

        return fetch(config.apiUrl + url, requestOptions).then(handleResponse);
    }
};
